import { IContact } from "./contact.model";
export class ICompany {
    isSelected: boolean;
    id: string;
    name: string;
    notes: string;
    contacts: IContact[];
    defaultContact: IContact;
    constructor(){
    }
}